export enum TermEndpointsEnum {
    Terms = '/api/v2/terms/%s', // :termId
}
